import Vue from "vue"
import VueRouter from "vue-router"
// import HomeView from "../views/HomeView.vue"




const routerPush = VueRouter.prototype.push;
 
VueRouter.prototype.push = function (location) {
 
    return routerPush.call(this, location).catch(err => {})
 
};
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () => import("@/layout/index"),
    meta: {
      title: '大米智课'
    },
    children: [
      {
        path: "/service",
        name: "service",
        component: () => import(/* webpackChunkName: "about" */ "../views/ServiceTwo.vue"),
        meta: {  
          title: '大米公开课_大米智课',
          requiresAuth: true,
          keywords: '南高齿,中国高速传动,齿轮,风电,中国传动',  
          description: '南京高速齿轮制造有限公司（下称：南高齿）以“为人类文明传递进步动力”为己任，致力于为全球用户提供齿轮箱与传动技术解决方案。公司始于1969年，隶属于港股上市公司“中国高速传动设备集团有限公司（00658.HK）”，旗下品牌“NGC”是江苏省重点培育和发展的国际知名品牌。'  
        }  
      },
      {
        path: "/about", // 公司简介
        name: "about",
        meta: {
          title: '公司简介_专注企业数字化培训赋能_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
      },
      {
        path: "/about2", // 大米咨询
        name: "about2",
        meta: {
          title: '大米资讯_企业培训知识_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/AboutView2.vue"),
      },
      {
        path: "/new", // 培训平台
        name: "new",
        meta: {
          title: '新闻动态_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/NewName.vue"),
      },
      {
        path: "/open", // 培训平台
        name: "open",
        meta: {
          title: '新闻动态_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/OpenName.vue"),
      },
      {
        path: "/span",
        name: "span",
        meta: {
          title: ''
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/Spandownload.vue"),
      },
      {
        path: "/ailab",
        name: "ailab",
        meta: {
          title: ''
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/AiLab.vue"),
      },
      {
        path: "/light",
        name: "light",
        meta: {
          title: '教育行业_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/Lightdownload.vue"),
      },
      {
        path: "/projectA",
        name: "projectA",
        meta: {
          title: '关于我们_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/LightProjectA.vue"),
      },
      {
        path: "/projectB",
        name: "projectB",
        meta: {
          title: '零售行业_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/LightProjectB.vue"),
      },
      {
        path: "/projectC",
        name: "projectC",
        meta: {
          title: '金融行业_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/LightProjectC.vue"),
      },
      {
        path: "/projectD",
        name: "projectD",
        meta: {
          title: '健康行业_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/LightProjectD.vue"),
      },
      {
        path: "/projectE",
        name: "projectE",
        meta: {
          title: '家电行业_大米智课行业解决方案'
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/LightProjectE.vue"),
      },
      {
        path: "/details2",
        name: "details2",
        meta: {
          title: ''
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/details2.vue"),//视频资讯内容
      },
      {
        path: "/details",
        name: "details",
        meta: {
          title: ''
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/details.vue"),//文本资讯内容
      },
      { // 移动->解决方案
        path: "/schemeA",
        name: "schemeA",
        meta: {
          title: '行业解决方案_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../yidong/schemeTopA.vue"),
      },
      { // 移动->下载
        path: "/schemeB",
        name: "schemeB",
        meta: {
          title: '下载与支持_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../yidong/schemeTopB.vue"),
      },
      { // 移动->关于我们
        path: "/schemeC",
        name: "schemeC",
        meta: {
          title: '联系我们_专注企业数字化培训赋能_大米智课'
        },
        component: () => import(/* webpackChunkName: "about" */ "../yidong/schemeTopC.vue"),
      },
    ],
  },
]

const router = new VueRouter({
  mode:'history',
  routes: [
    ...routes,
    {
      path: '*',
      redirect: '/'
    }
  ]
})

export default router
